<!-- <dashboardnav> -->
    <cradua-seismic-oml [oilmineralleases]="oilmineralleases$ | async" (oilminerallease)="onSubmitOilMineralLease($event)" (deleteOilMineralLeaseEvent)="onDeleteOilMineralLease($event)"
      *ngIf="(isLoadingOilMineralLease$ | async ) === false">
    </cradua-seismic-oml>
  
    <mrsoftapps-epims-reference-spinner *ngIf="(isLoadingOilMineralLease$ | async) === true">
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  <!-- </dashboardnav> -->
  